import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_jumpsuits: FaireCategoryEntity = {
  token: "cat_women-jumpsuits",
  type: "category",
  name: "Jumpsuits & rompers",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/jumpsuits-rompers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
